$('.product-single__thumbnails.has-slider').slick({
  infinite: false,
  slidesToShow: 6,
  slidesToScroll: 1,
  nextArrow: '<div class="arrow-right"><img src="//www.mellow-home.com/cdn/shop/t/63/assets/black-arrow-right.png?v=13200163168748177421721850667"></div>',
  prevArrow: '<div class="arrow-left"><img src="//www.mellow-home.com/cdn/shop/t/63/assets/black-arrow-left.png?v=79504478389581545231721850667"></div>'
});

$(".testimonial-slider").slick({
    arrows: true,
	centerMode: true,
    centerPadding: '60px',
    slidesToShow: 1,
    prevArrow: '<div class="arrow-left"><img src="//www.mellow-home.com/cdn/shop/t/63/assets/circle-arrow-left.png?v=93562171264679998231721850666"></div>',
    nextArrow: '<div class="arrow-right"><img src="//www.mellow-home.com/cdn/shop/t/63/assets/circle-arrow-right.png?v=45026510200723127491721850665"></div>'
});

$('.product-single__description .product-tab-title').click(function(){
	$(this).parent().toggleClass("active");
});

$(document).ready(function(){
  var w = $(".product-single__thumbnails-item.slick-active").width();
  $(".product-single__thumbnails-item").addClass("width-"+w);
});

$(".product-accordion__title").click(function(){
  //$(".product-accordion__title").removeClass("open");
  //$(".product-accordion__content").hide();
  $(this).toggleClass("open");
  $(this).parent().find(".product-accordion__content").toggle();
});